import { FilledInput, FormControl, FormHelperText, IconButton, InputAdornment, InputLabel } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { styled } from '@mui/styles';
import { useState } from 'react';

export const FormInput = styled(
    ({
        className,
        isPasswordInput,
        name,
        label,
        placeholder,
        value,
        onChange,
        onBlur,
        isIncorrect,
        errorMessage,
        variant,
        typeOfError,
        dataCy,
        disabled,
    }) => {
        const [visibility, setVisibility] = useState(isPasswordInput ? false : true);

        return (
            <FormControl variant="filled" fullWidth error={Boolean(isIncorrect)} className={className}>
                {value ? <InputLabel className="label">{label}</InputLabel> : null}
                <FilledInput
                    inputProps={{ 'data-cy': name + '-input' }}
                    data-cy={dataCy}
                    disabled={disabled}
                    name={name}
                    type={visibility ? 'text' : 'password'}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    className="input"
                    onBlur={onBlur ? onBlur : () => {}}
                    disableUnderline
                    label={value ? label : null}
                    endAdornment={
                        isPasswordInput ? (
                            <InputAdornment position="end">
                                <IconButton
                                    data-cy="toggle-password-visibility-button"
                                    aria-label="toggle password visibility"
                                    onClick={() => setVisibility(!visibility)}
                                    edge="end"
                                    size="large"
                                >
                                    {isPasswordInput && visibility ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                            </InputAdornment>
                        ) : null
                    }
                />
                {errorMessage && typeOfError !== 'auth/email-already-in-use' ? (
                    <FormHelperText className="helper" data-cy={`${dataCy}-error-info`}>
                        {errorMessage === '' ? null : errorMessage}
                    </FormHelperText>
                ) : null}
            </FormControl>
        );
    }
)(({ theme, errorMessage, placeholder, typeOfError, value }) => ({
    '& .input': {
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
        height: 47,
        marginTop: placeholder ? 10 : 0,
        background: '#FFFFFF',
        border: `1px solid ${errorMessage && typeOfError !== 'auth/email-already-in-use' ? '#FE5C5E' : '#E4E6EB'}`,
        borderRadius: 4,
        color: theme.palette.colors.subline,
        fontSize: 15,
        '& .MuiFilledInput-input': {
            padding: value === '' ? '12px 12px 13px' : '21px 13px 6px 13px',
        },
    },
    '& input:-webkit-autofill': {
        WebkitBackgroundClip: 'text',
    },
    '& .MuiFormLabel-root': {
        color: theme.palette.colors.lightGrey,
        padding: '8px 0 0 2px',
    },
    '& .MuiIconButton-edgeEnd': {
        color: theme.palette.colors.lightGrey,
    },
    '& .helper': {
        margin: '3px 0 8px 0',
        color: theme.palette.colors.red,
        fontSize: 12,
    },
}));
